<template>
	<div v-if="params.value">{{ params.value ? formatDate(params.value) : '' }}</div>
</template>

<script>
	export default {
		name: 'CellRendererDate',
	}
</script>
